<div
	class="modal fade"
	id="filtersModal"
	tabindex="-1"
	role="dialog"
	aria-labelledby="filtersModalLabel"
	aria-hidden="true"
>
	<div class="modal-dialog modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-body">
				<div class="form-floating mb-3">
					<input type="text" id="search" class="form-control" name="search" [(ngModel)]="filters.search" />
					<label class="form-label" for="search">Wyszukiwana fraza</label>
				</div>
			</div>
			<div class="modal-footer">
				<div class="container">
					<div class="row">
						<div class="col-sm-4">
							<button type="button" class="btn btn-secondary" (click)="filtersClear()">
								Wyczyść filtry
							</button>
						</div>
						<div class="col-sm-8 text-end">
							<button type="button" class="btn btn-primary me-2" (click)="filtersSave()">Pokaż</button>
							<button
								type="button"
								class="btn btn-secondary"
								(click)="filtersClose()"
								data-bs-dismiss="modal"
							>
								Anuluj
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
